import { makeAutoObservable, toJS } from 'mobx'
import { type State } from './State'
import { type ActionSpec } from './Types'

export class Action {
  state: State
  spec: ActionSpec

  static CONFIGURABLE_TYPES = [
    'reviews.create',
    'approvals.create',
    'read_receipts.create',
    'files.move',
    'accesses.create',
  ]

  private constructor(state: State, spec: ActionSpec) {
    this.state = state
    this.spec = spec
    makeAutoObservable(this)
  }

  static fromConfig(state: State, spec: ActionSpec) {
    return new Action(state, spec)
  }

  get type() {
    return this.spec.type
  }

  get config() {
    return this.spec.config
  }

  setConfig = (newConfig: ActionSpec['config']) => {
    this.spec.config = { ...this.spec.config, ...newConfig }
  }

  get isConfigurable() {
    return Action.CONFIGURABLE_TYPES.includes(this.type)
  }

  toJSON = () => {
    return toJS(this.spec)
  }

  destroy = () => {
    if (['reviews.create', 'approvals.create', 'read_receipts.create'].includes(this.type)) {
      this.state.childStates.forEach((childState) => childState.disconnect())
    }
    ;[this.state.entryActions, this.state.exitActions].forEach((actions) => {
      const index = actions.indexOf(this)
      if (index > -1) {
        actions.splice(index, 1)
      }
    })
  }
}
